/**
 * Compte en temps réel les drafts en attente d'intervention humaine
 * (status='ready_for_agent'). Utilisé pour les badges :
 *  - Sidebar principale : pastille sur l'icône Admin
 *  - Menu admin : badge sur l'item "Apply Queue (Agent)"
 *
 * Le listener Firestore (collectionGroup) n'est activé que si `enabled=true`,
 * pour ne pas faire un onSnapshot inutile depuis les comptes non-admin.
 */
import { useEffect, useState } from 'react';
import { collectionGroup, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export function useAdminQueueBadgeCount(enabled: boolean): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    const q = query(
      collectionGroup(db, 'drafts'),
      where('status', '==', 'ready_for_agent'),
    );
    const unsub = onSnapshot(
      q,
      (snap) => setCount(snap.size),
      (err) => {
        console.warn('[useAdminQueueBadgeCount]', err.message);
        setCount(0);
      },
    );
    return unsub;
  }, [enabled]);

  return count;
}
